<template>
  <div id="services" v-if="page">
    <rich-text :elements="page.document.content.filter( c => c.props.meta !== 'togglers')" :is-root="true"></rich-text>

    <div class="togglers">
      <div class="container" v-if="page">
        <b-collapse v-for="(solution, index) in page.document.content.find( c => c.props.meta === 'togglers').props.columns" :key="`solution-${index}`"
        :open="openTogglers[index]">
          <button class="button" slot="trigger" slot-scope="props" :class="props.open ? 'is-active' : ''">
            <h3 class="title">{{ solution.atoms[0].props.text }}</h3>
          </button>
          <div class="content columns is-multiline">
            <div v-html="solution.atoms[1].props.text"></div>
            <slot v-for="(point, index) in solution.list">
              <div class="column is-12 columns point" :key="`solution-point-${index}`">
                <b-icon icon="arrow-right is-1 column"></b-icon>
                <p class="is-11 column" >{{ point }}</p>
              </div>
            </slot>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import RichText from '@/components/RichText.vue';

export default {
  name: 'services',
  props: ['page'],
  components: {
    RichText,
  },
  data() {
    return {
      openTogglers: {},
    };
  },
};
</script>

<style lang='sass'>
  #services
    .introduction
      position: relative
      margin-bottom: 5rem
      padding: 3rem 0 3.5rem
      background: linear-gradient(to right, white 0%, white 30%, #ecf1f4 30%, #ecf1f4 100%)
      .column:first-child
        text-align: right
      h2
        position: relative
        display: inline-block
        margin-right: 8rem
        &::after
          content: ""
          position: absolute
          right: 0
          bottom: -1rem
          display: block
          height: 4px
          width: 1500px
          background-color: #fe3904

    .solutions
      figure
        padding: 0
        height: 4px
        width: 5%
        background-color: #fe3904
      .point
        align-items: center
      .icon
        margin: 0 1rem 0 0
        color: #fe3904

    .togglers
      .collapse
        max-width: 800px
        .collapse-content
          padding: 1.5rem 2rem 2.5rem
          .content
            > div > div
              position: relative
              margin-left: 2rem
              padding: 1.5rem 0
              &:before
                content: "\F054"
                position: absolute
                top: 50%
                left: -36px
                display: inline-block
                margin-top: -18px
                font: normal normal normal 24px/1 "Material Design Icons"
                font-size: 28px
                color: #fe3904
                text-rendering: auto
                line-height: inherit
</style>
